import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreeningDeviceSieveStrainerFineRake = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 120,
	viewBox: "0 0 80.0 120.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 0.0 L 80.0 0.0 L 80.0 80.0 L 40.0 120.0 L 0.0 80.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 31.43 23.44 L 38.51 16.38 L 63.91 41.9 L 56.82 48.95 M 46.98 24.89 L 39.89 31.94 M 55.44 33.39 L 48.36 40.45 M 42.48 20.39 L 35.39 27.44 M 51.1 28.89 L 44.02 35.94 M 59.6 37.39 L 52.52 44.44",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.5 0.75 L 80.0 79.5",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		})
	]
});
export default SvgScreeningDeviceSieveStrainerFineRake;
